import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchGetVillageSuggests,
  IGetVillageSuggestsRequest,
  TGetVillageSuggestsResponse,
} from '../repositories/countryside-search/v1/get-village-suggests';

export async function getVillageSuggests(httpApi: IHttpApi, parameters: IGetVillageSuggestsRequest) {
  const { response, statusCode } = await fetchGetVillageSuggests<
    TGetVillageSuggestsResponse,
    TGetVillageSuggestsResponse
  >({
    httpApi,
    parameters,
  });

  if (statusCode !== 200 || 'errors' in response) {
    throw response;
  }

  return response.suggests || [];
}
